export default __webpack_public_path__ + "static/media/avatar_146.ab018cee.png";